var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-customer',{attrs:{"title":_vm.title,"fields":_vm.fields,"resourceName":_vm.resourceName},scopedSlots:_vm._u([{key:"entity",fn:function(ref){
var input = ref.input;
return [_c('span',[_vm._v(_vm._s(input))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }